// extracted by mini-css-extract-plugin
module.exports = {"container":"ItemImageNotes_container__SC9aE","cover":"ItemImageNotes_cover__qJLtE"};